import { render, staticRenderFns } from "./DoKoRestrictionWedding.vue?vue&type=template&id=df9c0612&scoped=true&"
import script from "./DoKoRestrictionWedding.vue?vue&type=script&lang=ts&"
export * from "./DoKoRestrictionWedding.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoRestrictionWedding.vue?vue&type=style&index=0&id=df9c0612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9c0612",
  null
  
)

export default component.exports